import React, { useEffect, useState } from "react";
import { UserResponse } from "../types/AuthTypes";
import { getAllUsers } from "../services/authService";
import RegisterUserForm from "./RegisterUserForm";
import UserTable from "./UserTable";

const UserList = () => {
  const [users, setUsers] = useState<UserResponse[]>([]);
  
  async function fetchUser() {
    const data = await getAllUsers();  // Wait for API response
    setUsers(data); // Update state, triggers re-render
  }

  useEffect(() => {
    fetchUser();
  }, []);


  return (
    <div>
      <h1>User List</h1>
      <RegisterUserForm loadUsers={fetchUser} />
      <UserTable users={users} loadUsers={fetchUser} />
    </div>
  );
};

export default UserList;
